import type { Moment } from 'moment/moment';
import moment from 'moment/moment';

import { RIODateTime } from './RIODateTime.ts';

const PICKER_PARSE_FORMATS = [
    moment.ISO_8601,
    RIODateTime.PREDEFINED_FORMATS.GERMAN_DATE_TIME,
    RIODateTime.PREDEFINED_FORMATS.GERMAN_DATE,
    'HH:mm',
    'yyyy-MM-dd HH:mm',
    'yyyy-MM-dd hh:mm',
];

export const isoToLocalJSDate = (value?: string) => RIODateTime.TryFromISO(value)?.toLocal().toJSDate();

export const localJSDateToIso = (value: Date) =>
    RIODateTime.FromJSDate(value).toISOString({ suppressMilliseconds: false }) ?? '';

const localMomentToIso = (value: Moment) => {
    const dateTime = RIODateTime.TryFromLocalParts({
        year: value.year(),
        month: value.month() + 1,
        day: value.date(),
        hour: value.hour(),
        minute: value.minute(),
        second: value.second(),
        millisecond: value.millisecond(),
    });

    return dateTime?.toISOString({ suppressMilliseconds: false }) ?? '';
};

export const pickerValueToLocalIso = (value: string | Moment) => {
    if (moment.isMoment(value)) {
        return localMomentToIso(value);
    }

    if (value === '') {
        return '';
    }

    const parsedValue = moment(value, PICKER_PARSE_FORMATS, true);

    if (!parsedValue.isValid()) {
        return value;
    }

    return localJSDateToIso(parsedValue.toDate());
};
